import * as z from 'zod'

import { CreateWidgetPageVars, UpdateWidgetPageVars } from '@/common/api/params/widgetPage'
import { NameLabelMapping } from '@/common/app/message'
import { StringLength } from '@/common/form/schema'
import { WidgetPage } from '@/common/model/recommend/widgetPage'

export const AI_INSTRUCTIONS_MAX = 5000

export const widgetPageSchema = z.object({
  id: z.number().readonly().optional(),
  siteId: z.number().readonly(),
  name: z.string().min(1).max(StringLength.NORMAL_MAX),
  targetUrl: z.string().min(1).max(2000).url('正しいURLを入力してください'),
  aiInstructions: z.string().max(AI_INSTRUCTIONS_MAX).optional(),
  basicAuthUser: z.string().max(StringLength.NORMAL_MAX).optional(),
  basicAuthPass: z.string().max(StringLength.NORMAL_MAX).optional()
})

export type WidgetPageFormSchemaType = z.infer<typeof widgetPageSchema>

export const convertWidgetPageSchemaToVars = (
  schema: WidgetPageFormSchemaType
): UpdateWidgetPageVars | CreateWidgetPageVars => {
  const base = {
    name: schema.name,
    target_url: schema.targetUrl,
    ai_instructions: schema.aiInstructions ?? '',
    basic_auth_user: schema.basicAuthUser ?? ''
  }
  // パスワードは入力された場合のみ送信（空＝変更なし）
  const passPart = schema.basicAuthPass ? { basic_auth_pass: schema.basicAuthPass } : {}

  if (schema.id !== undefined) {
    return { site_id: schema.siteId, widget_page_id: schema.id, ...base, ...passPart }
  }
  return { site_id: schema.siteId, ...base, ...passPart }
}

export const convertWidgetPageToSchema = (widgetPage: WidgetPage): WidgetPageFormSchemaType => {
  return {
    id: widgetPage.id,
    siteId: widgetPage.site_id,
    name: widgetPage.name,
    targetUrl: widgetPage.target_url ?? '',
    aiInstructions: widgetPage.ai_instructions ?? '',
    basicAuthUser: widgetPage.basic_auth_user ?? '',
    basicAuthPass: ''
  }
}

export const makeDefaultWidgetPageSchema = (siteId: number): WidgetPageFormSchemaType => ({
  siteId,
  name: '',
  targetUrl: '',
  aiInstructions: '',
  basicAuthUser: '',
  basicAuthPass: ''
})

export const widgetPageNameLabelMapping: NameLabelMapping = {
  name: 'レコメンドパーツ設置ページ名',
  targetUrl: 'ページURL',
  aiInstructions: 'デザイン指示',
  basicAuthUser: 'Basic認証ユーザー名',
  basicAuthPass: 'Basic認証パスワード'
}
